import type { Question } from "../survey/schema";

// 質問タイプ別の VAD redemption (末尾無音) 閾値 = 発話終了判定 (spec 2026-07-18 §5.5)。
// long は「考える間」(『出身は…（1 秒）…北海道です』) で途中切断しないよう長め、
// scale / short / intent phase (resume-prompt / summary) は応答レイテンシ優先で
// Silero 既定の 800ms を維持する。値は docs/measurements/ の実測で調整する (原則 6)。
export const DEFAULT_REDEMPTION_MS = 800;
export const LONG_ANSWER_REDEMPTION_MS = 1800;

export function redemptionMsForQuestionType(type: Question["type"] | null): number {
  return type === "long" ? LONG_ANSWER_REDEMPTION_MS : DEFAULT_REDEMPTION_MS;
}
